import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";
import { Asset } from "../../types";
import { FeatureNames } from "~/modules/feature_flag/flags";
import { AssetSwapCta } from "~/modules/swap";
import { useMemo } from "react";
import { getSolanaTradableToken } from "~/modules/trade/utils";

export function AssetSwapLayout(props: { asset: Asset }) {
    const { asset } = props;
    const solanaToken = useMemo(() => getSolanaTradableToken(asset), [asset]);

    if (!solanaToken) {
        return null;
    }

    return (
        <FeatureFlag feature={FeatureNames.enableExperimentalFeatures}>
            <div className="w-full lg:w-80 lg:shrink-0">
                <AssetSwapCta asset={asset} token={solanaToken} />
            </div>
        </FeatureFlag>
    );
}
